import styled from "styled-components";

interface RadialChartStyleProps {
  status?: boolean;
}

export const RadialChartBox = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 140px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const RadialChartTick = styled.div<RadialChartStyleProps>`
  position: absolute;
  display: flex;
  width: 100%;
  max-width: 150px;
  bottom: 26px;
  color: ${(props) =>
    props.status === true
      ? props.theme.colors.white60
      : props.theme.colors.black60};
  justify-content: space-between;

  span {
    display: inline-block;
    width: 28px;
    text-align: center;
  }
`;

export const RadialChartUnitBox = styled.div<RadialChartStyleProps>`
  position: absolute;
  bottom: 10px;
  color: ${(props) =>
    props.status === true
      ? props.theme.colors.white80
      : props.theme.colors.black80};
  font-size: 1.2rem;
`;
